<script>
    import MoveAddressToProject from '../../Projects/Addresses/MoveAddressToProject';

    export default {
        extends: MoveAddressToProject,
        data() {
            return {
                actionRouteName: 'api.delivery-projects.move-selected-addresses.store',
                callbackRouteName: 'admin.delivery-projects.addresses.show',
            };
        },
    };
</script>
